import React from "react";
import { OcRoleFilterSubtypeView } from "./role-filter-subtype-view";
import { useOcRoleFilterSubtype } from "./use-role-filter-subtype";
import {
  OcRoleFilterAddItemProps,
  OcRoleFilterRemoveItemProps,
} from "oc/components";
import { ProductsT, RoleCategoriesT } from "oc/configs/constants";
import { RoleFilterInput } from "oc/types";

export interface OcRoleFilterSubtypeProps {
  type: keyof RoleFilterInput;
  queryType: "notAdmin" | "admin" | "import";
  roleFilters: RoleFilterInput;
  role: RoleCategoriesT;
  product: ProductsT;
  editable?: boolean;
  isCheckbox?: boolean;
  handleAddItem: (props: OcRoleFilterAddItemProps) => void;
  handleRemoveItem: (props: OcRoleFilterRemoveItemProps) => void;
}

export const OcRoleFilterSubtype: React.FC<OcRoleFilterSubtypeProps> = ({
  type,
  isCheckbox,
  editable = true,
  ...props
}) => {
  const extraProps = useOcRoleFilterSubtype({
    ...props,
    type,
    isCheckbox,
    editable,
  });

  return (
    <OcRoleFilterSubtypeView
      {...extraProps}
      type={type}
      isCheckbox={isCheckbox}
      editable={editable}
    />
  );
};
